import { render, staticRenderFns } from "./roomTypeSettings.vue?vue&type=template&id=dd6416b4&scoped=true&"
import script from "./roomTypeSettings.vue?vue&type=script&lang=js&"
export * from "./roomTypeSettings.vue?vue&type=script&lang=js&"
import style0 from "./roomTypeSettings.vue?vue&type=style&index=0&id=dd6416b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd6416b4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBreadcrumbs,VBtn,VCol,VForm,VIcon,VSimpleTable,VTextField})
